// Função utilitária para converter uma string ISO UTC para horário local (HH:mm)
export function formatNotificationTimeToLocal(
  dateString: string,
  locale = navigator.language
): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  // Formata para HH:mm no fuso local do navegador
  return date.toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
}
